































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class PlaceSocialNetworks extends Vue {
    @Prop() socialNetworks!: any;

    get cleanFbUrl() {
      if (this.socialNetworks && this.socialNetworks.fbUrl) {
        return this.socialNetworks.fbUrl.replace(/(https*:\/\/)/, "");
      } else {
        return null;
      }
    }

    get cleanIgUser() {
      console.log (this.socialNetworks)
      if (this.socialNetworks && this.socialNetworks.igUser) {
        return this.socialNetworks.igUser.replace("@", "")
      } else {
        return null;
      }
    }

  get cleanTwUser() {
    console.log (this.socialNetworks)
    if (this.socialNetworks && this.socialNetworks.twUser) {
      return this.socialNetworks.twUser.replace("@", "")
    } else {
      return null;
    }
  }

}
